<form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (submit)="onSubmit()">
  <h2>{{ 'content.about-subject' | translate }}</h2>

  <app-phone-form-row phoneFormControlName="phone" phoneNumberCssClass="col-md-4" [displayErrors]="formSubmitted" [formGroup]="f"></app-phone-form-row>

  <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
    <button class="tu-button secondary tu-shadow" type="button" (click)="onBack()">{{ 'content.back' | translate }}</button>
    <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
  </div>
</form>
